//BuildingGeometry.js



import * as THREE from "three";

import * as MyFunctions from "../MyFunctions.js";
import * as StructuralMember from "../classes/StructuralMember.js";
import * as PreDimension from "../classes/PreDimension.js";
import * as BuildingResult from "../classes/BuildingResult.js";
import * as MemberViz from "../classes/MemberViz.js";

//
//This function creates a 2D-Grid in x-direction
//
function createGridLinesX(boundingRectangleLines, ySpac) {

	var lineCurve1 = new THREE.LineCurve(boundingRectangleLines[2].start, boundingRectangleLines[2].end);
	var lineCurve2 = new THREE.LineCurve(boundingRectangleLines[3].start, boundingRectangleLines[3].end);

	var pts1 = [lineCurve1.getSpacedPoints(ySpac)];
	var pts2 = [lineCurve2.getSpacedPoints(ySpac)];
	pts1 = pts1[0];
	pts2 = pts2[0];

	var gridLinesX = [];

	for (let i = 1; i < pts1.length - 1 ; i++) {
		var gridLine = new THREE.Line3(new THREE.Vector3(pts1[i].x, pts1[i].y, 0), new THREE.Vector3(pts2[i].x, pts2[i].y, 0));
		gridLinesX.push(gridLine)	;
	}

	return gridLinesX;
}




//
//This function creates a 2D-Grid in y-direction
//
function createGridLinesY(boundingRectangleLines, xSpac) {
		
	var lineCurve1 = new THREE.LineCurve(boundingRectangleLines[0].start, boundingRectangleLines[0].end);
	var lineCurve2 = new THREE.LineCurve(boundingRectangleLines[1].start, boundingRectangleLines[1].end);

	var pts1 = [lineCurve1.getSpacedPoints(xSpac)];
	var pts2 = [lineCurve2.getSpacedPoints(xSpac)];
	pts1 = pts1[0];
	pts2 = pts2[0];

	var gridLinesY = [];

	for (let i = 1; i < pts1.length - 1 ; i++) {
		var gridLine = new THREE.Line3(new THREE.Vector3(pts1[i].x, pts1[i].y, 0), new THREE.Vector3(pts2[i].x, pts2[i].y, 0));
		gridLinesY.push(gridLine);
	}

	return gridLinesY;
}


//
//This function creates a 2D-Grid for secondary beams
//
function createGridLinesSecondaryBeams(boundingRectangleLines, xBays, yBays, actualXSpan, actualYSpan, beamDist) {

	var bays;
	var span; 

	var lineCurve1;
	var lineCurve2;

	if(actualXSpan <= actualYSpan) {
		lineCurve1 = new THREE.LineCurve(boundingRectangleLines[2].start, boundingRectangleLines[2].end);
		lineCurve2 = new THREE.LineCurve(boundingRectangleLines[3].start, boundingRectangleLines[3].end);	
		bays = yBays;
		span = actualYSpan; 
	}
	else {
		lineCurve1 = new THREE.LineCurve(boundingRectangleLines[0].start, boundingRectangleLines[0].end);
		lineCurve2 = new THREE.LineCurve(boundingRectangleLines[1].start, boundingRectangleLines[1].end);
		bays = xBays;
		span = actualXSpan; 
	}
		
	var pts1 = lineCurve1.getSpacedPoints(bays);
	var pts2 = lineCurve2.getSpacedPoints(bays);

	var lines1 = [];
	var lines2 = [];

	for (let i = 0; i < pts1.length - 1 ; i++) {
		var line1 = new THREE.LineCurve(pts1[i], pts1[i + 1]);
		lines1.push(line1);
		var line2 = new THREE.LineCurve(pts2[i], pts2[i + 1]);
		lines2.push(line2);	
	}

	var beamBays = Math.round(span / beamDist);
	var gridLines = [];

	for (let i = 0; i < lines1.length; i++) {
		var tempPts1 = lines1[i].getSpacedPoints(beamBays);
		var tempPts2 = lines2[i].getSpacedPoints(beamBays);
		
		for (let j = 1; j < tempPts1.length - 1 ; j++) {
			var gridLine = new THREE.Line3(new THREE.Vector3(tempPts1[j].x, tempPts1[j].y, 0), new THREE.Vector3(tempPts2[j].x, tempPts2[j].y, 0));
			gridLines.push(gridLine);
		}
	}

	return gridLines;
}


//
//This function gets gridlines in x-direction inside the building geometry
//
function createIntersectedGridLinesX(gridLinesX, buildingOutlines) {

	var intersectedGridLinesX = [];

	for (let i = 0; i < gridLinesX.length; i++) {

		var segments = MyFunctions.getInnerSegments(gridLinesX[i], buildingOutlines);
		
		for (let j = 0; j < segments.length; j++) {
			
			intersectedGridLinesX.push(segments[j]);
		}
	}

	return intersectedGridLinesX;
}





//
//This function gets gridlines in y-direction inside the building geometry
//
function createIntersectedGridLinesY(gridLinesY, buildingOutlines) {

	var intersectedGridLinesY = [];

	for (let i = 0; i < gridLinesY.length; i++) {

		var segments = MyFunctions.getInnerSegments(gridLinesY[i], buildingOutlines);
		
		for (let j = 0; j < segments.length; j++) {
			
			intersectedGridLinesY.push(segments[j]);
		}
	}

	return intersectedGridLinesY;
}


//
//This function gets gridlines for the secondary beams inside the building geometry
//
function createIntersectedSecondaryBeams(gridLinesSecondaryBeams, buildingOutlines) {

	var intersectedGridLinesSecondaryBeams = [];

	for (let i = 0; i < gridLinesSecondaryBeams.length; i++) {

		var segments = MyFunctions.getInnerSegments(gridLinesSecondaryBeams[i], buildingOutlines);
		
		for (let j = 0; j < segments.length; j++) {
			
			intersectedGridLinesSecondaryBeams.push(segments[j]);
		}
	}

	return intersectedGridLinesSecondaryBeams;
}




//
//This function gets the position for the beams in x-Direction
//
function getXBeamsPositions(segmentedGridLinesX, segmentedGridLinesY) {

	var xBeams = [];

	for (let i = 0; i < segmentedGridLinesX.length; i++) {

		var intersectionPts = MyFunctions.intersectLineLines(segmentedGridLinesX[i], segmentedGridLinesY);
		intersectionPts.push(segmentedGridLinesX[i].start, segmentedGridLinesX[i].end);

		intersectionPts.sort(function (x, y) {
			return x.x -y.x;
		})

		// console.log(intersectionPts)

		for (let j = 0; j < intersectionPts.length - 1; j++) {
			var segment = new THREE.Line3(intersectionPts[j], intersectionPts[j+1]);
			xBeams.push(segment);
		}
	}

	return xBeams;
}



//
//This function gets the position for the beams in y-Direction
//
function getYBeamsPositions(segmentedGridLinesY, segmentedGridLinesX) {

	var yBeams = [];

	for (let i = 0; i < segmentedGridLinesY.length; i++) {

		var intersectionPts = MyFunctions.intersectLineLines(segmentedGridLinesY[i], segmentedGridLinesX);
		intersectionPts.push(segmentedGridLinesY[i].start, segmentedGridLinesY[i].end);

		intersectionPts.sort(function (x, y) {
			return x.y -y.y;
		})

		// console.log(intersectionPts)

		for (let j = 0; j < intersectionPts.length - 1; j++) {
			var segment = new THREE.Line3(intersectionPts[j], intersectionPts[j+1]);
			yBeams.push(segment);
		}
	}

	return yBeams
}


//
//This function creates the beams in y-Direction
//
function getSecondaryBeamsPositions(segmentedSecondaryBeams, segmentedGridLinesX, segmentedGridLinesY, xSpan, ySpan) {

	var secondaryBeams = [];

	if(xSpan <= ySpan) {
		secondaryBeams = getXBeamsPositions(segmentedSecondaryBeams, segmentedGridLinesY)
	}
	else {
		secondaryBeams = getYBeamsPositions(segmentedSecondaryBeams, segmentedGridLinesX)
	}

	return secondaryBeams
}





//
//This function intersects the intersected Grid Lines in x-direction with the cores
//
function intersectXWithCores(intersectedGridLinesX, coreLines) {

	var segments = [];

	for (let i = 0; i < intersectedGridLinesX.length; i++) {
		
		var intersections = MyFunctions.intersectLineLines(intersectedGridLinesX[i], coreLines);

		intersections.push(intersectedGridLinesX[i].start, intersectedGridLinesX[i].end);
		
		// console.log("Core intersections");
		// console.log(intersections);

		if(intersections.length > 0) {
			intersections.sort(function (x, y) {
				return x.x -y.x;
			})

			for (let j = 0; j < intersections.length-1; j=j+2) {
				var segment = new THREE.Line3(intersections[j], intersections[j+1]);
				
				segments.push(segment);
			}
		}
	}

	// console.log("Segments X");
	// console.log(segments);
	return segments;
}



//
//This function intersects the intersected Grid Lines in x-direction with the cores
//
function intersectYWithCores(intersectedGridLinesY, coreLines) {

	var segments = [];

	for (let i = 0; i < intersectedGridLinesY.length; i++) {
		
		var intersections = MyFunctions.intersectLineLines(intersectedGridLinesY[i], coreLines);

		intersections.push(intersectedGridLinesY[i].start, intersectedGridLinesY[i].end);
		
		// console.log("Core intersections");
		// console.log(intersections);

		if(intersections.length > 0) {
			intersections.sort(function (x, y) {
				return x.y -y.y;
			})

			for (let j = 0; j < intersections.length-1; j=j+2) {
				var segment = new THREE.Line3(intersections[j], intersections[j+1]);
				
				segments.push(segment);
			}
		}
	}

	// console.log("Segments Y");
	// console.log(segments);
	return segments;
}


//
//This function intersects the intersected Grid Lines for Secondary Beams with the cores
//
function intersectSecondaryBeamsWithCores(intersectedSecondaryBeams, coreLines, xSpan, ySpan) {

	var segments = [];

	for (let i = 0; i < intersectedSecondaryBeams.length; i++) {
		
		var intersections = MyFunctions.intersectLineLines(intersectedSecondaryBeams[i], coreLines);

		intersections.push(intersectedSecondaryBeams[i].start, intersectedSecondaryBeams[i].end);
		
		// console.log("Core intersections");
		// console.log(intersections);

		if(intersections.length > 0) {
			if(xSpan <= ySpan) {
				intersections.sort(function (x, y) {
					return x.x -y.x;
				})
			}
			else {
				intersections.sort(function (x, y) {
					return x.y -y.y;
				})
			}

			for (let j = 0; j < intersections.length-1; j=j+2) {
				var segment = new THREE.Line3(intersections[j], intersections[j+1]);
				
				segments.push(segment);
			}
		}
	}

	// console.log("Segments Y");
	// console.log(segments);
	return segments;
}



//
//This function gets the positions of the outer columns
//
function getOuterColumnsPositions(intersectedGridLinesX, intersectedGridLinesY) {

	var outerColumnsPositions = [];

	for (let i = 0; i < intersectedGridLinesX.length; i++) {
		outerColumnsPositions.push(intersectedGridLinesX[i].start, intersectedGridLinesX[i].end);
	}

	for (let i = 0; i < intersectedGridLinesY.length; i++) {
		outerColumnsPositions.push(intersectedGridLinesY[i].start, intersectedGridLinesY[i].end);
	}

	return outerColumnsPositions;
}


//
//This function gets the positions of the edge columns
//
function getEdgeColumnsPositions(bufferGeometry) {

	var edgeColumnsPositions = [];

	const posAttr = bufferGeometry.attributes.position.array;

	for(let i = 0; i < posAttr.length; i=i+3) {
		var vec = new THREE.Vector3(posAttr[i], posAttr[i+1], posAttr[i+2]);
		edgeColumnsPositions.push(vec);
	}

	return edgeColumnsPositions;
}




//
//This function gets the positions of the inner columns
//
function getInnerColumnsPositions(segmentedGridLinesX, segmentedGridLinesY) {

	var innerColumnsPositions = [];

	for (let i = 0; i < segmentedGridLinesX.length; i++) {
		
		var intersections = MyFunctions.intersectLineLines(segmentedGridLinesX[i], segmentedGridLinesY);

		if(intersections.length > 0) {
			for (let j = 0; j < intersections.length; j++) {
				innerColumnsPositions.push(intersections[j]);
			}
		}
	}

	return innerColumnsPositions;
}



//
//This function creates columns from their position
//
function createColumns(columnPositions, levelCount, actualFloorHeight, material, structSystem, liveLoad, deadLoad, actXSpan, actYSpan, type) {
	var columns = [];

		var designLoad = 1.35 * liveLoad +  1.5 * deadLoad;

		console.log('designLoad from createColumns' + designLoad);


		for (let i = 0; i < levelCount; i++) {

			for (let j = 0; j < columnPositions.length; j++) {

				// var column = new THREE.Line3(new THREE.Vector3(columnPositions[j].x, columnPositions[j].y, actualFloorHeight * i), 
				// 				new THREE.Vector3(columnPositions[j].x, columnPositions[j].y, actualFloorHeight * (i+1)));

				var columnLoad = designLoad * actXSpan * actYSpan * (levelCount - i);

				if(type == "outer") {
					columnLoad/2;
				} 
				else if(type == "edge") {
					columnLoad/4;
				}

				var column = new StructuralMember.Column(new THREE.Vector3(columnPositions[j].x, columnPositions[j].y, actualFloorHeight * i), 
								new THREE.Vector3(columnPositions[j].x, columnPositions[j].y, actualFloorHeight * (i+1)), 
								material, i, columnLoad);

				var length = column.distance();

				var crossSection = PreDimension.predimColumn(material, structSystem, columnLoad, length);
				
				// console.log("crossSection");
				// console.log(crossSection);

				column.crossSection = crossSection;
				column.carbon = BuildingResult.calculateCarbonForColumn(material, structSystem, crossSection) * length;
				column.cost = BuildingResult.calculateCostsForColumn(material, structSystem, crossSection) * length;
				column.weight = BuildingResult.calculateWeightForColumn(material, structSystem, crossSection) * length;

				if(material == "Steel") {
					column.shape = crossSection.shape;
				}
				else if(material == "Hybrid" && structSystem == "Beam") {
					column.shape = crossSection.shape;
				}
				else {
					column.shape = MemberViz.getColumnShape(crossSection);
					// column.shape = "Shape";
				}

				columns.push(column);
			}
		}
	return columns;
}


//
//This function creates beams from their position (old -> new one below)
//
// function createBeams(beamPositions, levelCount, actualFloorHeight) {
// 	var beams = [];
// 		for (let i = 0; i < levelCount; i++) {
// 			for (let j = 0; j < beamPositions.length; j++) {
// 				var beam = new THREE.Line3(new THREE.Vector3(beamPositions[j].start.x, beamPositions[j].start.y, actualFloorHeight * (i+1)), 
// 							new THREE.Vector3(beamPositions[j].end.x, beamPositions[j].end.y, actualFloorHeight * (i+1)));

// 				// var beam = new StructuralMember.Beam(new THREE.Vector3(beamPositions[j].start.x, beamPositions[j].start.y, actualFloorHeight * (i+1)), 
// 				// 									new THREE.Vector3(beamPositions[j].end.x, beamPositions[j].end.y, actualFloorHeight * (i+1)), 
// 				// 									material, type, levelCount, );


// 				beams.push(beam);
// 			}
// 		}
// 	return beams;
// }




//
//This function creates beams from position, material, type, system ...
//
function createBeams(xBeamsPositions, yBeamsPositions, secondaryBeamPosition, xSpan, ySpan, material, 
						structSystem, levelCount, actualFloorHeight, liveload, deadLoad, beamDistance) {
							
	var beams = [];

	var load = 1.35 * liveload + 1.5 * deadLoad;

	var xType;
	var yType;
	if (xSpan <= ySpan) {
		xType = "Secondary";
		yType = "Primary";		
	}
	else {
		xType = "Primary";
		yType = "Secondary";
	}


	//Concrete
	//----------------------------------------------------------------------------------------------
	if (material == "Concrete") {
		if (structSystem == "Plate") {
			beams = [];
		}
		else {
			for (let i = 0; i < levelCount; i++) {
				//X-Beams
				for (let j = 0; j < xBeamsPositions.length; j++) {
					var xConcreteBeam = new StructuralMember.Beam(new THREE.Vector3(xBeamsPositions[j].start.x, xBeamsPositions[j].start.y, actualFloorHeight * (i+1)), 
														new THREE.Vector3(xBeamsPositions[j].end.x, xBeamsPositions[j].end.y, actualFloorHeight * (i+1)), 
														material, xType, i, load * ySpan);
					beams.push(xConcreteBeam);
				}
				//Y-Beams
				for (let j = 0; j < yBeamsPositions.length; j++) {
					var yConcreteBeam = new StructuralMember.Beam(new THREE.Vector3(yBeamsPositions[j].start.x, yBeamsPositions[j].start.y, actualFloorHeight * (i+1)), 
														new THREE.Vector3(yBeamsPositions[j].end.x, yBeamsPositions[j].end.y, actualFloorHeight * (i+1)), 
														material, yType, i, load * xSpan);
					beams.push(yConcreteBeam);
				}
			}
		}	
	}

	//Steel
	//----------------------------------------------------------------------------------------------
	else if(material == "Steel") {
		for (let i = 0; i < levelCount; i++) {
			//X-Beams
			for (let j = 0; j < xBeamsPositions.length; j++) {
				var xCompositeBeam = new StructuralMember.Beam(new THREE.Vector3(xBeamsPositions[j].start.x, xBeamsPositions[j].start.y, actualFloorHeight * (i+1)), 
													new THREE.Vector3(xBeamsPositions[j].end.x, xBeamsPositions[j].end.y, actualFloorHeight * (i+1)), 
													material, xType, i, load * ySpan);
				beams.push(xCompositeBeam);
			}
			//Y-Beams
			for (let j = 0; j < yBeamsPositions.length; j++) {
				var yCompositeBeam = new StructuralMember.Beam(new THREE.Vector3(yBeamsPositions[j].start.x, yBeamsPositions[j].start.y, actualFloorHeight * (i+1)), 
													new THREE.Vector3(yBeamsPositions[j].end.x, yBeamsPositions[j].end.y, actualFloorHeight * (i+1)), 
													material, yType, i, load * xSpan);
				beams.push(yCompositeBeam);
			}
			//Secondary-Beams
			for (let j = 0; j < secondaryBeamPosition.length; j++) {
				var secondaryCompositeBeam = new StructuralMember.Beam(new THREE.Vector3(secondaryBeamPosition[j].start.x, secondaryBeamPosition[j].start.y, actualFloorHeight * (i+1)), 
													new THREE.Vector3(secondaryBeamPosition[j].end.x, secondaryBeamPosition[j].end.y, actualFloorHeight * (i+1)), 
													material, "Secondary", i, load * beamDistance);
				beams.push(secondaryCompositeBeam);
			}
		}	
	}

	//Timber
	//----------------------------------------------------------------------------------------------
	else if(material == "Timber") {
		for (let i = 0; i < levelCount; i++) {
			//X-Beams
			for (let j = 0; j < xBeamsPositions.length; j++) {
				var xTimberBeam = new StructuralMember.Beam(new THREE.Vector3(xBeamsPositions[j].start.x, xBeamsPositions[j].start.y, actualFloorHeight * (i+1)), 
													new THREE.Vector3(xBeamsPositions[j].end.x, xBeamsPositions[j].end.y, actualFloorHeight * (i+1)), 
													material, xType, i, load * ySpan);
				beams.push(xTimberBeam);
			}
			//Y-Beams
			for (let j = 0; j < yBeamsPositions.length; j++) {
				var yTimberBeam = new StructuralMember.Beam(new THREE.Vector3(yBeamsPositions[j].start.x, yBeamsPositions[j].start.y, actualFloorHeight * (i+1)), 
													new THREE.Vector3(yBeamsPositions[j].end.x, yBeamsPositions[j].end.y, actualFloorHeight * (i+1)), 
													material, yType, i, load * xSpan);
				beams.push(yTimberBeam);
			}
			if(structSystem == "Beam") {
				//Secondary-Beams
				for (let j = 0; j < secondaryBeamPosition.length; j++) {
					var secondaryTimberBeam = new StructuralMember.Beam(new THREE.Vector3(secondaryBeamPosition[j].start.x, secondaryBeamPosition[j].start.y, actualFloorHeight * (i+1)), 
														new THREE.Vector3(secondaryBeamPosition[j].end.x, secondaryBeamPosition[j].end.y, actualFloorHeight * (i+1)), 
														material, "Secondary", i, );
					beams.push(secondaryTimberBeam);
				}
			}
		}
	}

	//Hybrid
	//----------------------------------------------------------------------------------------------
	else if(material == "Hybrid") {
		for (let i = 0; i < levelCount; i++) {
			//X-Beams
			for (let j = 0; j < xBeamsPositions.length; j++) {
				var xHybridBeam = new StructuralMember.Beam(new THREE.Vector3(xBeamsPositions[j].start.x, xBeamsPositions[j].start.y, actualFloorHeight * (i+1)), 
													new THREE.Vector3(xBeamsPositions[j].end.x, xBeamsPositions[j].end.y, actualFloorHeight * (i+1)), 
													material, xType, i, load * ySpan);
				beams.push(xHybridBeam);
			}
			//Y-Beams
			for (let j = 0; j < yBeamsPositions.length; j++) {
				var yHybridBeam = new StructuralMember.Beam(new THREE.Vector3(yBeamsPositions[j].start.x, yBeamsPositions[j].start.y, actualFloorHeight * (i+1)), 
													new THREE.Vector3(yBeamsPositions[j].end.x, yBeamsPositions[j].end.y, actualFloorHeight * (i+1)), 
													material, yType, i, load * ySpan);
				beams.push(yHybridBeam);
			}
			//Secondary-Beams
			for (let j = 0; j < secondaryBeamPosition.length; j++) {
				var secondaryHybridBeam = new StructuralMember.Beam(new THREE.Vector3(secondaryBeamPosition[j].start.x, secondaryBeamPosition[j].start.y, actualFloorHeight * (i+1)), 
													new THREE.Vector3(secondaryBeamPosition[j].end.x, secondaryBeamPosition[j].end.y, actualFloorHeight * (i+1)), 
													material, "Secondary", i, load * beamDistance);
				beams.push(secondaryHybridBeam);
			}
		}
	}

	return beams;
}




//
//This function creates core lines
//
function createCoreLines(corePts) {
	var coreLines = [];
	var coreLine1 = new THREE.Line3(corePts[0], corePts[1]);
	var coreLine2 = new THREE.Line3(corePts[1], corePts[2]);
	var coreLine3 = new THREE.Line3(corePts[2], corePts[3]);
	var coreLine4 = new THREE.Line3(corePts[3], corePts[0]);

	coreLines.push(coreLine1, coreLine2, coreLine3, coreLine4);

	return coreLines;
}


//
//This function claculates only the plate height of a floor slab
//
function getSlabHeight(slab) {

	var plateHeight; 

	//
	if(slab.material == "Steel" && slab.type == "Plate") {
		plateHeight = slab.height.height;
	}
	else if(slab.material == "Hybrid" && slab.type == "Plate") {
		plateHeight = slab.height.heightConcrete;
	}
	else {
		plateHeight = slab.height;
	}

	return plateHeight;
}


//
//Calculate structural ceiling height
//
function getStructuralCeilingHeight (material, structSystem, slab, slabHeight, beams) {

	var beamHeight; 
	var structCeilingHeight; 

	var beamHeights = [];
	var itBeamHeight;

	//Steel
	if(material == 'Steel') {
		for (let i = 0; i < beams.length; i++) {
			itBeamHeight = beams[i].crossSection.profilHeight;
			beamHeights.push(itBeamHeight); 
		}

		beamHeight = Math.max(...beamHeights);
		structCeilingHeight = slabHeight + beamHeight; 

		return structCeilingHeight;
	}

	//Concrete
	else if(material == 'Concrete') {
		if(structSystem == 'Plate') {
			structCeilingHeight = slabHeight; 
			console.log('slabHeight'); 
			console.log(slabHeight); 
		}
		else if(structSystem == 'Beam') {
			for (let i = 0; i < beams.length; i++) {
				itBeamHeight = beams[i].crossSection.beamHeight;
				beamHeights.push(itBeamHeight); 
			}

			beamHeight = Math.max(...beamHeights);
			structCeilingHeight = slabHeight + beamHeight;  
		}

		return structCeilingHeight;
	}

	//Timber
	else if(material == 'Timber') {
		if(structSystem == 'Plate') {
			for (let i = 0; i < beams.length; i++) {
				itBeamHeight = beams[i].crossSection.beamHeight;
				beamHeights.push(itBeamHeight); 
			}

			beamHeight = Math.max(...beamHeights);
			structCeilingHeight = slabHeight + beamHeight; 
		}
		else if(structSystem == 'Beam') {
			for (let i = 0; i < beams.length; i++) {
				itBeamHeight = beams[i].crossSection.beamHeight;
				beamHeights.push(itBeamHeight); 
			}

			beamHeight = Math.max(...beamHeights);
			structCeilingHeight =  beamHeight; 
		}

		return structCeilingHeight;
	}

	//Hybrid
	else if(material == 'Hybrid') {
		if(structSystem == 'Plate') {
			for (let i = 0; i < beams.length; i++) {
				itBeamHeight = slab.height.heightTimber;
				beamHeights.push(itBeamHeight); 
			}

			beamHeight = Math.max(...beamHeights);
			structCeilingHeight = slabHeight + beamHeight; 
		}
		else if(structSystem == 'Beam') {
			for (let i = 0; i < beams.length; i++) {
				itBeamHeight = beams[i].crossSection.profilHeight;
				beamHeights.push(itBeamHeight); 
			}

			beamHeight = Math.max(...beamHeights);
			structCeilingHeight = slabHeight + beamHeight; 
		}

		return structCeilingHeight;
	}

}



//------------------------------------------------------------------------
//Export
//------------------------------------------------------------------------


export { createGridLinesX,						createGridLinesY,			createIntersectedGridLinesX,	createIntersectedGridLinesY,	getXBeamsPositions,				getYBeamsPositions,
			intersectXWithCores, 				intersectYWithCores,		getInnerColumnsPositions,		getOuterColumnsPositions,		getEdgeColumnsPositions,
			createCoreLines,					createColumns,				createBeams,					createGridLinesSecondaryBeams,	createIntersectedSecondaryBeams,
			intersectSecondaryBeamsWithCores,	getSecondaryBeamsPositions,	getSlabHeight, 					getStructuralCeilingHeight}
